import { Stack, Typography } from '@mui/material';
import type { Customer } from '@vy/types';
import { VyDialog2 } from '../../../../../../../../components/new-design/feedback/VyDialog2';

export type CustomerRelatedEntitiesProps = {
  children: Customer[];
  isOpen: boolean;
  onClose: () => void;
};

export const CustomerRelatedEntities: React.FC<CustomerRelatedEntitiesProps> = ({
  children,
  isOpen,
  onClose,
}) => {
  const relatedEntities = children.map((child) => {
    return <Typography key={child.id}>{child.name}</Typography>;
  });

  return (
    <VyDialog2 title="Related Entities" open={isOpen} maxWidth="sm" onClose={onClose} fullWidth>
      <Stack direction="column" spacing={1} sx={{
        minHeight: '100px'
      }}>
        {relatedEntities}
      </Stack>
    </VyDialog2>
  );
};
